import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeleteQuoteListModel } from 'src/app/models/quoteModel/quote.model';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { QuoteService } from 'src/app/services/quote.service';

@Component({
  selector: 'app-delete-quote',
  templateUrl: './delete-quote.component.html',
  styleUrls: ['./delete-quote.component.css']
})
export class DeleteQuoteComponent implements OnInit {

  Loader: boolean = false;
  deleteQuoteList: DeleteQuoteListModel = new DeleteQuoteListModel();

  constructor(private requestQuote: QuoteService, private alertify: AlertifyService, private modalService: NgbModal) { }

  ngOnInit() {
    this.requestQuote.getQuoteId.subscribe((id: string) => {
      this.deleteQuoteList.Id = +id;
    });
  }

  deleteQuote() {
    this.Loader = true;
    this.requestQuote.DeleteQuote(this.deleteQuoteList)
      .subscribe(response => {
        var responseBody = JSON.parse(response._body);
        if (responseBody.isSuccess) {
          this.alertify.success(responseBody.responseMessage);
          this.modalService.dismissAll();
          this.Loader = false;
        } else {
          this.Loader = false
        }
      })
  }

  onCancel() {
    this.modalService.dismissAll();
  }
}
